// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zjaY","col":"styles_col__2ugXP","actions":"styles_actions__3o5uu","conflict":"styles_conflict__3M0b3"};